<template>
  <div>
    <navigation style="position:absolute;z-index:100;" />
    <div class="main" style="margin-top: -10px">
      <div class="as-main" style="background: white">
        <div class="as-title">亮照申请步骤</div>
        <div class="as-items clearfix">
          <div class="as-img">
            <img src="../assets/images/as-1.png" alt="" />
            <!-- <img src="${basePath}/${headLogo}" class="as-img-logo">-->
          </div>
          <div class="as-items-contain as-items-1">
            <div class="as-items-title">1、注册并登录</div>
            <div class="as-items-info">在"{{clientTitle}}"注册并登录，选择"电子标识申请"</div>
          </div>
        </div>

        <div class="as-items clearfix">

          <div class="as-items-contain as-items-2">
            <div class="as-items-title">2、提交亮照申请资料</div>
            <div class="as-items-info">• 线上资料提交。在"亮照申请页"填写申请内容，点击"保存"按钮并"提交"。</div>
            <div class="as-items-info">• 线下资料提交。企业将营业执照复印件，网站负责人身份证复印件，网站备案信息</div>
            <div class="as-items-info">(工信部网站查询打印)域名所有权证明的纸质资料提交所在地县、区级以上(含县、区)市场监督管理局。</div>
          </div>
          <div class="as-img">
            <img src="../assets/images/as-2.png" alt="" />
            <!-- <img src="${basePath}/${headLogo}" class="as-img-logo">-->
          </div>
        </div>

        <div class="as-items clearfix">
          <div class="as-img">
            <img src="../assets/images/as-3.png" alt="" />
            <!-- <img src="${basePath}/${headLogo}" class="as-img-logo">-->
          </div>
          <div class="as-items-contain as-items-3">
            <div class="as-items-title">3、等待核对</div>
            <div class="as-items-info">等待核对。通过访问"{{clientTitle}}"，查看电子标识的核对状态。</div>
          </div>
        </div>
        <div class="as-items clearfix">
          <div class="as-items-contain as-items-4">
            <div class="as-items-title">4、亮照公示期</div>
            <div class="as-items-info">亮照公示期。核对通过后，企业亮照信息会在网站"公告信息"栏目进行为期7天的公示。</div>
          </div>
          <div class="as-img">
            <img src="../assets/images/as-4.png" alt="" />
            <!--<img src="${basePath}/${headLogo}" class="as-img-logo">-->
          </div>
        </div>

        <div class="as-items clearfix" style="border-bottom: 0px;">
          <div class="as-img">
            <img src="../assets/images/as-5.png" alt="" />
            <!--  <img src="${basePath}/${headLogo}" class="as-img-logo">-->
          </div>
          <div class="as-items-contain as-items-5">
            <div class="as-items-title">5、通知申请结果</div>
            <div class="as-items-info">通知申请结果，您将会收到亮照申请是否成功的邮件。</div>
            <div class="as-items-info">• 申请失败。请按照邮件提示的失败原因进行修改后，重新申请。</div>
            <div class="as-items-info">• 申请成功。可按照邮件提示的流程下载标识，添加网站源码，将电子标识添加到网站首页下方的醒目位置。</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import navigation from './navigation'
  import {getClientTitle1} from '../assets/js/utils'
  export default {
    name: 'applyStep',
    components: {
      'navigation': navigation,
    },
    created() {
      var _self = this
      getClientTitle1(_self,function (res){
        _self.clientTitle = res
      })
    },
    data() {
      return {
        clientTitle: null,
      }
    },
    methods: {
    }
  }
</script>

<style scoped="scoped">
  @import '../assets/css/newStyle.css';
  .content .load-more {
    height: 90px;
    width: 70px;
    color: #848484;
    font-size: 16px;
    font-weight: bold;
    padding-top: 10px;
    position: relative;
    left: 0px;
    top: 30px;
    margin: 0 auto;
    cursor: pointer;
  }

  .report-list>li {
    width: 100%;
    height: 90px;
    padding-top: 30px;
    border-bottom: 0.5px solid #C4C4C4;
  }
</style>



// WEBPACK FOOTER //
// src/components/applyStep.vue